var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LngLink',{attrs:{"to":_vm.to},nativeOn:{"mouseenter":function($event){return _vm.over($event)},"mouseleave":function($event){return _vm.out($event)}}},[_vm._t("default"),_c('Arrow')],2)}
var staticRenderFns = []

export { render, staticRenderFns }